import { render, staticRenderFns } from "./AreaCrags.vue?vue&type=template&id=1b0216f5&scoped=true"
import script from "./AreaCrags.vue?vue&type=script&lang=js"
export * from "./AreaCrags.vue?vue&type=script&lang=js"
import style0 from "./AreaCrags.vue?vue&type=style&index=0&id=1b0216f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0216f5",
  null
  
)

export default component.exports